import { mapEnumToOptions } from '@abp/ng.core';

export enum ProformaStatus {
  Draft = 0,
  InProgress = 1,
  Send = 2,
  Rejected = 3,
  Resend = 4,
  Accepted = 5,
  ProjectCreated = 6,
}

export const proformaStatusOptions = mapEnumToOptions(ProformaStatus);
